export default "__VITE_ASSET__ccd0a4b7__"